import React, { FC, Fragment, MouseEventHandler } from "react";
import { useNavigate } from "react-router-dom";
import useHandleCancel from "@hooks/use-handle-cancel";
import LoadingSpinner from "@components/indicators/LoadingSpinner/LoadingSpinner";
import Button from "../Button/Button";

export type Variant = "primary" | "secondary" | "submit" | "cancel" | "text";

interface EditorCompleteButtonsProps {
    hasUnsavedChanges: boolean;
    isSaving: boolean;
    isNew?: boolean; // Display "Create" instead of "Save"
    onSave: MouseEventHandler<HTMLButtonElement>;
}

const EditorCompleteButtons: FC<EditorCompleteButtonsProps> = ({
    hasUnsavedChanges,
    isSaving,
    isNew,
    onSave,
}) => {
    const navigate = useNavigate();
    const handleCancel = useHandleCancel(hasUnsavedChanges);

    const handleFinish = () => {
        navigate(-1);
    };

    const hasUnsavedChangesBtnText = isNew ? "Create" : "Save";

    return (
        <>
            <Button variant="cancel" size="medium" disabled={isSaving} onClick={handleCancel}>
                Cancel
            </Button>
            <Button variant="submit" size="medium" onClick={hasUnsavedChanges ? onSave : handleFinish}>
                {isSaving
                    ? <LoadingSpinner size="small" color="white" />
                    : hasUnsavedChanges ? hasUnsavedChangesBtnText : "Finish"}
            </Button>
        </>
    );
};

export default EditorCompleteButtons;
